import { render, staticRenderFns } from "./DigitalSignInput.vue?vue&type=template&id=10f84a18&scoped=true"
import script from "./DigitalSignInput.vue?vue&type=script&lang=js"
export * from "./DigitalSignInput.vue?vue&type=script&lang=js"
import style0 from "./DigitalSignInput.vue?vue&type=style&index=0&id=10f84a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f84a18",
  null
  
)

export default component.exports